import { useEffect } from "react";
import { useSignalR } from "../utils/context/signal-r-context";

export const useChatMessages = (chatId, onMessage) => {
    const signalR = useSignalR();         
    const connection = signalR?.connection;
    const connected = signalR?.connected;

    useEffect(() => {
        if (!connected || !connection || !chatId) return;

        connection.invoke("JoinChat", chatId).catch(console.error);

        const handler = (message) => onMessage?.(message);
        connection.on("ReceiveMessage", handler);

        return () => {
            connection.invoke("LeaveChat", chatId).catch(() => {});
            connection.off("ReceiveMessage", handler);
        };
    }, [chatId, connection, connected, onMessage]);
};

export const useChatUpdated = (onUpdate) => {
    const signalR = useSignalR();
    const connection = signalR?.connection;
    const connected = signalR?.connected;

    useEffect(() => {
        if (!connected || !connection) return;

        const handler = (update) => onUpdate?.(update);
        connection.on("UpdateChatSummary", handler);

        return () => {
            connection.off("UpdateChatSummary", handler);
        };
    }, [connection, connected, onUpdate]);
};

export const useChatCreated = () => {
    const signalR = useSignalR();
    const connection = signalR?.connection;
    const connected = signalR?.connected;

    useEffect(() => {
        if (!connected || !connection) return;

        // define handler once
        const handler = async (chat) => {
            try {
                await connection.invoke("JoinUserChats", [chat.chatId]);
            } catch (err) {
                console.error("Failed to join chat", err);
            }
        };

        connection.on("ChatCreated", handler);

        return () => {
            connection.off("ChatCreated", handler);
        };
    }, [connection, connected]);
};

